var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonChart',{attrs:{"data":_vm.processedData,"config":_vm.chartConfig,"active-tab":_vm.activeTab,"xAxisUnit":_vm.getXAxisUnit,"container-class":"daily-usage-chart-container","height":"250px"}})
}
var staticRenderFns = []

export { render, staticRenderFns }